var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1961 1983",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg__woman",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", null), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M758.477 380.668C815.66 380.668 836.457 319.802 868.944 286.4C892.188 262.502 931.858 269.628 943.601 236.171C973.128 152.041 894.098 92.8286 790.999 92.8286C687.9 92.8286 618.384 144.76 603.374 222.826C588.364 300.893 655.378 380.668 758.477 380.668Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.197 369.714C855.596 387.076 887.431 395.465 902.374 392.04C939.845 383.453 943.291 261.577 914.297 213.53C885.304 165.483 736.254 144.541 728.741 239.738C726.133 272.777 741.737 302.263 764.792 326.323L723.453 497.629H843.533L823.197 369.714Z",
    fill: "#DEC1A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001.74 177.112C993.486 207.905 957.542 225.235 920.345 217.008C897.877 216.737 869.801 213.435 839.39 207.067C839.876 216.89 838.705 227.588 835.594 239.198C832.847 249.45 828.565 259.956 823.086 270.32C818.298 262.193 810.725 255.698 801.905 253.335C777.232 246.723 755.562 258.9 750.789 276.714C744.731 299.323 756.138 319.91 778.836 327.395C749.254 354.769 713.9 371.88 685.219 364.195C630.743 349.598 608.141 279.012 625.486 214.279C626.096 212.005 626.756 209.76 627.464 207.546C606.219 213.066 585.457 222.199 564.544 231.399L564.544 231.399C520.11 250.946 475 270.79 423.152 256.897C319.416 229.101 324.563 45.099 469.498 83.934C568.064 110.345 613.365 135.216 650.442 163.979C663.83 146.982 680.724 134.202 699.112 127.043C703.73 124.594 710.278 122.822 718.406 121.73C723.418 120.906 728.485 120.499 733.57 120.533C760.821 119.63 798.768 124.011 839.855 133.759C847.527 135.579 855.022 137.518 862.294 139.554C870.922 107.827 908.993 90.4675 947.439 100.769C985.959 111.09 1010.27 145.27 1001.74 177.112Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.427 866.843L871.706 1414.1L962.914 1879.5H1034.43L938.051 866.843H683.427Z",
    fill: "#DEC1A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.427 866.843L871.706 1414.1L962.914 1879.5H1034.43L938.051 866.843H683.427Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.071 866.843C628.859 1167.32 613.809 1322.3 610.947 1349.6C608.084 1376.9 568.892 1553.91 476.107 1888.67L552.309 1865.4C698.947 1558.38 748.915 1398.82 765.733 1358.5C782.551 1318.19 827.22 1154.3 899.738 866.843H616.071Z",
    fill: "#DEC1A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.521 1856.78C481.512 1856.34 480.333 1856.78 479.886 1857.79C477.121 1864.02 468.283 1884.73 468.283 1894.88C468.283 1906.92 472.793 1930 472.793 1930C488.493 1930 754.99 1930 754.99 1930C754.99 1930 765.99 1897.67 742.29 1895.09C718.591 1892.51 702.915 1890.43 702.915 1890.43L567.929 1836.93C567.437 1836.74 566.877 1836.96 566.654 1837.44L556.658 1859C556.658 1859 534.719 1868.1 521.002 1868.1C509.442 1868.1 488.744 1859.49 482.521 1856.78Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M952.835 1856.78C951.825 1856.34 950.646 1856.78 950.2 1857.79C947.434 1864.02 938.597 1884.73 938.597 1894.88C938.597 1906.92 943.106 1930 943.106 1930C958.806 1930 1225.3 1930 1225.3 1930C1225.3 1930 1236.3 1897.67 1212.6 1895.09C1188.9 1892.51 1173.23 1890.43 1173.23 1890.43L1038.24 1836.93C1037.75 1836.74 1037.19 1836.96 1036.97 1837.44L1026.97 1859C1026.97 1859 1005.03 1868.1 991.315 1868.1C979.755 1868.1 959.057 1859.49 952.835 1856.78Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.41 866.843L738.463 1145.66H982.978L946.52 866.843H658.41Z",
    fill: "#DE4539"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.38 866.843C573.87 972.139 598.37 1145.66 598.37 1145.66H847.888L916.5 866.843H613.38Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1265.68 919.144L1123.94 796.214L1076.87 868.633L1224.25 945.889C1261.21 997.646 1282.91 1020.01 1289.37 1012.98C1294.81 1007.05 1292.31 1000.55 1290.02 994.568C1288.23 989.906 1286.56 985.555 1288.85 982.026C1294.09 973.968 1323.68 978.583 1351.55 984.03C1379.42 989.477 1372.97 977.305 1367.05 970.952C1340.71 952.053 1306.92 934.784 1265.68 919.144ZM430.248 1097.75C444.91 1071.3 494.841 813.551 494.841 813.551L599.397 813.916C599.397 813.916 502.559 1091.85 494.841 1108.86C484.814 1130.95 501.845 1163.05 513.394 1184.81C515.18 1188.18 516.836 1191.3 518.24 1194.1C502.215 1200.47 494.518 1192.76 486.403 1184.64C477.237 1175.47 467.538 1165.76 444.707 1175.2C435.886 1178.85 427.539 1183.16 419.385 1187.38C391.216 1201.93 365.339 1215.31 330.136 1196C324.556 1192.93 318.44 1181.41 333.216 1172.4C370.03 1149.96 423.08 1110.68 430.248 1097.75Z",
    fill: "#DEC1A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.974 423.484L835.238 416.886C909.725 582.322 1039.77 732.641 1225.38 867.844L1085.13 1019.34C899.54 826.828 785.145 628.21 791.974 423.484Z",
    fill: "#512DA8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.5 939L804.5 939L955.5 939C955.5 939 921 627.5 829 404.531L744.013 400.223C744.013 539.687 724.941 732.519 686.5 939Z",
    fill: "#DEC1A7"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.257 1053.67C470.389 631.062 735.981 399.765 735.981 399.765L736.074 399.838C736.089 399.814 736.104 399.79 736.119 399.765H743.705C757.321 400.182 785.182 401.267 785.182 401.267L813.264 472.615C817.719 603.101 865.303 998.541 865.303 998.541H613.129C613.558 1016.67 614.508 1035.06 616.035 1053.67H428.257Z",
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.172 1000.29C611.16 921.336 619.038 847.199 632.181 780.108C639.055 859.719 653.422 955.514 683.427 1000.29H613.172Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.971 862.394L793.5 810.924V862.394H668.971Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 600.5C956 642.75 930.928 677 900 677C869.072 677 844 642.75 844 600.5C844 558.25 826.072 498 857 498C887.928 498 956 558.25 956 600.5Z",
    fill: "#DEC1A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 618.434,
    y: 382.676,
    width: 341.101,
    height: 596.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1961,
    height: 1983,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.0181334c4089622be65c52fc011ab45f.svg";
export { ForwardRef as ReactComponent };